import { IconComponentVideo } from '@lessonup/ui-components';
import React from 'react';
import { PinComponentPlaceholder } from '../../components/PinComponentPlaceholder';

export interface VideoPinComponentPlaceholderProps {
  style?: React.CSSProperties;
  onDoubleClick?(): void;
}

export const VideoPinComponentPlaceholder: React.FC<VideoPinComponentPlaceholderProps> = ({ style, onDoubleClick }) => {
  return (
    <PinComponentPlaceholder style={style} onDoubleClick={onDoubleClick}>
      <IconComponentVideo color="#848991" />
    </PinComponentPlaceholder>
  );
};
